import { Component, OnInit, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { LogEntry } from 'src/app/models/log-entry'

@Component({
  selector: 'app-log-detalhes',
  templateUrl: 'log-detalhes.component.html',
  styleUrls: ['./log-detalhes.component.css'],
  standalone: false
})
export class LogDetalhesComponent implements OnInit {
  tipoLog?: 'ERRO' | 'LOGIN' | 'INSERT' | 'UPDATE' | 'UNDO' | 'CARGA_HORARIA' | 'NOTIFY'
  detalhes: any = {}

  constructor(public dialogRef: MatDialogRef<LogDetalhesComponent>, @Inject(MAT_DIALOG_DATA) public data: LogEntry) {}

  ngOnInit(): void {
    if (this.data.nivel == 'Erro') this.tipoLog = 'ERRO'
    else if (this.data.acao == 'LOGIN') this.tipoLog = 'LOGIN'
    else if (this.data.acao == 'INSERT_CARGA_HORARIA') this.tipoLog = 'CARGA_HORARIA'
    else if (this.data.acao == 'UPDATE_CARGA_HORARIA') this.tipoLog = 'CARGA_HORARIA'
    else if (this.data.acao.startsWith('INSERT')) this.tipoLog = 'INSERT'
    else if (this.data.acao.startsWith('UPDATE')) this.tipoLog = 'UPDATE'
    else if (this.data.acao.startsWith('UNDO')) this.tipoLog = 'UNDO'
    else if (this.data.acao.startsWith('NOTIFY')) this.tipoLog = 'NOTIFY'

    if (this.data.detalhesJSON) {
      this.detalhes = JSON.parse(this.data.detalhesJSON)
      if (this.detalhes.authorities) {
        for (let i = 0; i < this.detalhes.authorities.length; i++) {
          this.detalhes.authorities[i] = this.detalhes.authorities[i].replace('ROLE_UNESP.POSGRAD-PAADES_', '')
        }
      }
    }
  }

  formatPerfis(authorities: string[]): string {
    return authorities.join(' ')
  }
}
